<template>
  <el-dialog :visible.sync="dialogVisible" width="90%" destroy-on-close>
    <div class="right-home product-list" ref="bookListWrapper" style="width: auto; position: relative">
      <div class="breadcrumb">产品列表</div>
      <div class="right-main">
        <!--      查询订单-->
        <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline" v-if="!isShowAssociationed">
          <el-row>
            <!-- <el-row> -->
            <el-col :span="6">
              <el-form-item label="产品名称:">
                <el-input v-model="formInline.spuName" placeholder="请输入产品名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品性质:">
                <el-select v-model="formInline.spuProperty" placeholder="请选择" clearable>
                  <el-option label="" value="">全部</el-option>
                  <el-option v-for="item in natureList" :key="item.id" :label="item.dictValue" :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="产品分类:" v-permission="'pms:admin:category:list'">
                <el-cascader :show-all-levels="false" placeholder="请选择" clearable v-model="formInline.categoryId" :props="props">
                </el-cascader>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="产品属性:">
                <el-select v-model="formInline.isSeries" placeholder="请选择" clearable>
                  <el-option label="" value="">全部</el-option>
                  <el-option label="普通产品" value="0"></el-option>
                  <el-option label="套系产品" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-col :span="6" class="fn-right form-btn" style="margin-top:20px; margin-bottom: 20px;">
          <el-button class="search-ok" @click="addProduct" round>{{ isShowAssociationed ? '添加产品' : '取消关联' }}</el-button>
          <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round v-if="!isShowAssociationed">查询</el-button>
        </el-col>
        <div class="data-list">
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column label="产品ID" prop="id" min-width="10px">
            </el-table-column>
            <el-table-column prop="spuName" label="产品名称" min-width="10px">
            </el-table-column>
            <el-table-column label="产品主图" min-width="10">
              <template v-slot="scope">
                <img :src="scope.row.spuImage" alt="">
              </template>
            </el-table-column>
            <el-table-column prop="propertyName" label="产品性质" min-width="10">
              <template slot-scope="scope"> {{ scope.row.spuProperty === 'NORMAL' ? '通货' : scope.row.spuProperty === 'CUSTOM' ? '定制' : '未定义' }} </template>
            </el-table-column>
            <el-table-column prop="propertyName" label="产品属性" min-width="10">
              <template slot-scope="scope"> {{ scope.row.isSeries ? '套系产品' : '普通产品' }} </template>
            </el-table-column>
            <el-table-column prop="propertyName" label="产品状态" min-width="10">
              <template slot-scope="scope"> {{ scope.row.isHidden ? '隐藏' : '显示' }} </template>
            </el-table-column>
            <el-table-column prop="cate" label="产品分类" min-width="10">
            </el-table-column>
            <!-- <el-table-column label="单独推送平台数量" min-width="10">
              <template slot-scope="scope">
                <span v-if="('pms:admin:store:list')" @click="$router.push({ path: '/pushstore', query: { id: scope.row.id } })" class="color-blue">{{ scope.row.pushCounter }}</span>
                <span v-else>{{ scope.row.pushCounter }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="上架状态" min-width="10">
              <template slot-scope="scope"> {{ scope.row.onSale ? '已上架' : '已下架' }} </template>
            </el-table-column>
            <el-table-column label="操作" min-width="10px">
              <template v-slot="scope">
                <span @click="checkItem(scope.row)" class="color-blue" v-if="!scope.row.isShowAssociationed">关联<br></span>
                <span @click="checkItem(scope.row)" class="color-blue" v-if="scope.row.isShowAssociationed">取消关联</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--    分页-->
        <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import imgSrc from '@/assets/images/code.svg'
import store from '@/store'
import {
  spuList,
  categoryList,
  queryAllSubs,
  spuProperty,
  customGetProductes,
  customGetAllProductIds,
  customCategoryAddProduct,
  customCategoryCancelProduct
} from '@/api/pms'
export default {
  name: 'product-list',
  components: {
    VPagination
  },
  data () {
    return {
      dialogVisible: false,
      id: 0,
      props: !this.$hasPermission('pms:admin:category:list') ? {} : {
        checkStrictly: true,
        emitPath: false,
        lazy: true,
        lazyLoad (node, resolve) {
          const { level, value } = node
          if (level === 0) {
            categoryList(value).then(res => {
              let nodes = res.data.data.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.bottom || item.id === 4
                }
              })
              resolve(nodes)
            })
          } else if (level === 1) {
            queryAllSubs(value).then(res => {
              let nodes = res.data.data.subCategoryList.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.subCategoryList.length === 0,
                  subCategoryList: item.subCategoryList
                }
              })
              resolve(nodes)
            })
          } else {
            let nodes = node.data.subCategoryList.map(item => {
              return {
                value: item.id,
                label: item.categoryName,
                leaf: item.subCategoryList.length === 0,
                subCategoryList: item.subCategoryList
              }
            })
            resolve(nodes)
          }
        }
      },
      deleteSpuId: '',
      deleteDialog: false,
      natureList: [],
      formInline: {
        isSeries: '',
        categoryId: 10,
        onSale: '1',
        spuName: '',
        spuProperty: ''
      },
      tableData: [],
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      catagrayId: '',
      isShowAssociationed: true,
      allIds: []
    }
  },
  async created () {
    if (this.$hasPermission('pms:admin:property:list')) {
      // 获取产品性质
      await this.getProNature()
    }
  },
  methods: {
    show (id) {
      this.catagrayId = id
      this.isShowAssociationed = true
      this.getProList(this.queryInfo)
      this.dialogVisible = true
    },
    onSubmit () {
      this.getProList(this.queryInfo)
    },
    async getProNature () {
      // 获取产品性质
      await spuProperty().then((res) => {
        this.natureList = res.data.data
      })
    },
    aaaa (item, str, list) {
      if (item.subCategory !== undefined) {
        str = '>' + item.categoryName + str
        return this.aaaa(item.subCategory, str, list)
      } else {
        str = item.categoryName + str
        list.ownCategoryId = item.id
        return str
      }
    },
    async getProList (val) {
      if (this.isShowAssociationed) {
        await customGetProductes({ pageNum: val.pageNum, pageSize: val.pageSize }, this.catagrayId).then((res) => {
          if (res.data.success) {
            if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
              this.queryInfo.pageNum--
              this.getProList(this.queryInfo)
            }
            let list = res.data.data.records
            list.forEach((item, index) => {
              item.cate = this.aaaa(item.category, '', item)
              item.isShowAssociationed = true
            })
            this.tableData = list
            this.queryInfo.total = res.data.data.total
          }
        })
      } else {
        await spuList({ pageNum: val.pageNum, pageSize: val.pageSize, spuVO: { ...this.formInline, spuIds: this.allIds } }).then((res) => {
          if (res.data.success) {
            if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
              this.queryInfo.pageNum--
              this.getProList(this.queryInfo)
            }
            let list = res.data.data.records
            list.forEach((item, index) => {
              item.cate = this.aaaa(item.category, '', item)
              item.isShowAssociationed = false
            })
            this.tableData = list
            this.queryInfo.total = res.data.data.total
          }
        })
      }
    },
    checkItem (item) {
      if (item.isShowAssociationed) {
        // 取消关联
        customCategoryCancelProduct(this.catagrayId, [item.id]).then((res) => {
          if (res.data.success) {
            item.isShowAssociationed = false
            this.allIds.splice(this.allIds.indexOf(item.id), 1)
          }
        })
      } else {
        // 关联
        customCategoryAddProduct(this.catagrayId, [item.id]).then((res) => {
          if (res.data.success) {
            item.isShowAssociationed = true
            this.allIds.push(item.id)
          }
        })
      }
    },

    changePage (val) {
      this.queryInfo = val
      this.getProList(this.queryInfo)
    },
    addProduct () {
      if (this.isShowAssociationed) {
        // 获取所有已关联的产品
        customGetAllProductIds(this.catagrayId).then((res) => {
          if (res.data.success) {
            this.allIds = res.data.data
            this.isShowAssociationed = false
            this.queryInfo.pageNum = 1
            this.getProList(this.queryInfo)
          }
        })
      } else {
        this.isShowAssociationed = true
        this.queryInfo.pageNum = 1
        this.getProList(this.queryInfo)
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

@{deep} .el-cascader {
  line-height: 30px;
}
</style>
